const haaloData = [
    {
        "id": 1,
        "options": [
            {
                "statement": "I believe great ideas can come from anywhere",
                "associatedLetter": "A"
            },
            {
                "statement": "I believe most great ideas come from those in charge",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 2,
        "options": [
            {
                "statement": "I thrive on regular interaction with others",
                "associatedLetter": "C"
            },
            {
                "statement": "I thrive in an independent creative environment",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 3,
        "options": [
            {
                "statement": "I am determined to win and persistent in doing so",
                "associatedLetter": "M"
            },
            {
                "statement": "I am determined to impact the world and not afraid to challenge the status quo",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 4,
        "options": [
            {
                "statement": "I love to compete and never shy away from a healthy debate",
                "associatedLetter": "M"
            },
            {
                "statement": "I love supporting others even if that means I don't get the credit",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 5,
        "options": [
            {
                "statement": "I seek to be of service, power doesn't drive me",
                "associatedLetter": "H"
            },
            {
                "statement": "I seek to be on a solid team of equals, status doesn't drive me",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 6,
        "options": [
            {
                "statement": "I always color inside the lines",
                "associatedLetter": "H"
            },
            {
                "statement": "I march to the beat of my own drum",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 7,
        "options": [
            {
                "statement": "I am quick to do exactly what is needed when called upon",
                "associatedLetter": "H"
            },
            {
                "statement": "I am quick to speak up and challenge current thinking",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 8,
        "options": [
            {
                "statement": "I typically seek out perspectives other than my own",
                "associatedLetter": "H"
            },
            {
                "statement": "I typically rely heavily on my own perspective ",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 9,
        "options": [
            {
                "statement": "I am great at delivering under clear direction and guidance",
                "associatedLetter": "H"
            },
            {
                "statement": "I am great at executing my part of a plan",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 10,
        "options": [
            {
                "statement": "I believe winning is the only thing that matters",
                "associatedLetter": "M"
            },
            {
                "statement": "I believe the cause is the only thing that matters",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 11,
        "options": [
            {
                "statement": "I believe a chain of command leads to better teamwork",
                "associatedLetter": "H"
            },
            {
                "statement": "I believe trust is the key to better teamwork",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 12,
        "options": [
            {
                "statement": "I like to know how I can best support my teammates ",
                "associatedLetter": "C"
            },
            {
                "statement": "I like to know how success is defined by the organization",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 13,
        "options": [
            {
                "statement": "I build relationships with people who share my same vision ",
                "associatedLetter": "A"
            },
            {
                "statement": "I build relationships with people that can help advance my career",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 14,
        "options": [
            {
                "statement": "I am high energy and others look to me for answers",
                "associatedLetter": "A"
            },
            {
                "statement": "I am a good listener and others count on my support",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 15,
        "options": [
            {
                "statement": "I believe manipulation isn't bad if the cause is just",
                "associatedLetter": "A"
            },
            {
                "statement": "I believe manipulation isn't bad if that's what it takes to win",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 16,
        "options": [
            {
                "statement": "I work best when we are measured as a group",
                "associatedLetter": "C"
            },
            {
                "statement": "I work best when we are focused on our vision",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 17,
        "options": [
            {
                "statement": "I am most successful when I have others around me who are supportive",
                "associatedLetter": "C"
            },
            {
                "statement": "I am most successful on a winning team no matter what role I play",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 18,
        "options": [
            {
                "statement": "I often make friends with my coworkers",
                "associatedLetter": "C"
            },
            {
                "statement": "I tend to view my coworkers as competition",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 19,
        "options": [
            {
                "statement": "I like to understand the goal but then be left alone to execute",
                "associatedLetter": "M"
            },
            {
                "statement": "I like to understand the goal but then work with my team to execute",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 20,
        "options": [
            {
                "statement": "I win based on creativity and innovation",
                "associatedLetter": "A"
            },
            {
                "statement": "I win based on hustle and grit",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 21,
        "options": [
            {
                "statement": "I prefer to be surrounded by people with the same objective",
                "associatedLetter": "H"
            },
            {
                "statement": "I prefer to be surrounded by people who care about each other",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 22,
        "options": [
            {
                "statement": "I thrive in areas where I know my next step but can always handle a curveball",
                "associatedLetter": "H"
            },
            {
                "statement": "I thrive in a winning environment where everyone competes with each other",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 23,
        "options": [
            {
                "statement": "I love working within a team of people where we are recognized as a whole",
                "associatedLetter": "H"
            },
            {
                "statement": "I love to stand out as the result of my talents and contribution",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 24,
        "options": [
            {
                "statement": "I believe advancement comes from following the rules",
                "associatedLetter": "H"
            },
            {
                "statement": "I believe advancement comes from being the best performer",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 25,
        "options": [
            {
                "statement": "I enjoy working on a creative team with the ability to bring in new ideas ",
                "associatedLetter": "A"
            },
            {
                "statement": "I enjoy working on a team with a clear objective from leadership",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 26,
        "options": [
            {
                "statement": "I will stop at nothing to create the future I see",
                "associatedLetter": "A"
            },
            {
                "statement": "I will stop at nothing to support my team",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 27,
        "options": [
            {
                "statement": "I struggle to connect with people who don't believe in what I do",
                "associatedLetter": "A"
            },
            {
                "statement": "I feel connected to others who believe in what I believe",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 28,
        "options": [
            {
                "statement": "I take tremendous pride in the accuracy of my work",
                "associatedLetter": "H"
            },
            {
                "statement": "I take tremendous pride in adding value to a high-performing team",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 29,
        "options": [
            {
                "statement": "I believe in collective accountability",
                "associatedLetter": "C"
            },
            {
                "statement": "I believe in personal accountability ",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 30,
        "options": [
            {
                "statement": "I connect my success to my ability to help my leader succeed",
                "associatedLetter": "H"
            },
            {
                "statement": "I connect my success to how quickly I am able to grow in my career",
                "associatedLetter": "M"
            }
        ]
    }
];

export default haaloData;